'use client';

import { useSyncExternalStore } from 'react';

type BreakpointsTypes = 'sm' | 'md' | 'lg' | 'xl' | '2xl';
type RangeType = 'min' | 'max';

const getBreakpoint = (range: RangeType) => ({
  sm: `(${range}-width: 640px)`,
  md: `(${range}-width: 768px)`,
  lg: `(${range}-width: 1024px)`,
  xl: `(${range}-width: 1200px)`,
  '2xl': `(${range}-width: 1600px)`,
});

const SERVER_SNAPSHOT = { matches: false, isLoading: true };
const CLIENT_SNAPSHOT_TRUE = { matches: true, isLoading: false };
const CLIENT_SNAPSHOT_FALSE = { matches: false, isLoading: false };

const getServerSnapshot = () => SERVER_SNAPSHOT;

const getSnapshot = (query: string) => {
  if (typeof window === 'undefined') {
    return SERVER_SNAPSHOT;
  }

  const matches = window.matchMedia(query).matches;

  return matches ? CLIENT_SNAPSHOT_TRUE : CLIENT_SNAPSHOT_FALSE;
};

const useBreakpoint = (breakpoint: BreakpointsTypes, range: RangeType = 'min') => {
  const query = getBreakpoint(range)[breakpoint];

  const subscribe = (callback: () => void) => {
    if (typeof window === 'undefined') {
      return () => {};
    }

    const mediaQueryList = window.matchMedia(query);
    mediaQueryList.addEventListener('change', callback);
    return () => mediaQueryList.removeEventListener('change', callback);
  };

  const result = useSyncExternalStore(subscribe, () => getSnapshot(query), getServerSnapshot);

  return result;
};

export default useBreakpoint;
